import styled from 'styled-components';

const BaseBlock = styled.div`
  margin-top: 40px;
`;

export default BaseBlock;
